export const inputIds = {
    changePasswordConfirmPassword: 'changePasswordConfirmPassword',
    changePasswordCurrentPassword: 'changePasswordCurrentPassword',
    changePasswordNewPassword: 'changePasswordNewPassword',
};
